import { useState, useRef, useEffect } from 'react';

import { Button } from "@pentabd/ui";

import { capitalizeFirstLetter } from "@utils/capitalize";

interface ButtonGroupType {
  btnGroupData: string[];
  activeState: number | null;
  action: (arg: number) => void;
}

export const ButtonGroup = ({
  btnGroupData,
  activeState,
  action,
}: ButtonGroupType) => {

  const containerRef = useRef<HTMLDivElement>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  const checkOverflow = () => {
    const container = containerRef.current;

    !!container && console.log(container.scrollLeft)
    setShowLeftArrow(!!container && container.scrollLeft > 0);
    setShowRightArrow(!!container && container.scrollLeft < container.scrollWidth - container.clientWidth);
  };

  const scrollButtons = (direction: number) => {
    const container = containerRef.current;
    if (container) {
      const newScrollPosition = scrollPosition + direction * container.clientWidth;
      setScrollPosition(Math.max(0, Math.min(newScrollPosition, container.scrollWidth - container.clientWidth)));
    }
  };

  useEffect(() => {
    checkOverflow();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollPosition]);


  return (
    <div className="button-container" ref={containerRef}>
      {showLeftArrow && (
        <div className="arrow" onClick={() => scrollButtons(-1)}>
          ❮
        </div>
      )}
      <div className="btn-group d-flex" style={{ transform: `translateX(-${scrollPosition}px)` }}>
        {btnGroupData.map((btnText: string, i: number) => (
          <Button
            key={i}
            fill={activeState === i ? `fill` : `outline`}
            type="info"
            size="xs"
            onClick={() => action(i)}
          >
            {capitalizeFirstLetter(btnText)}
          </Button>
        ))}
      </div>
      {showRightArrow && (
        <div className="arrow" onClick={() => scrollButtons(1)}>
          ❯
        </div>
      )}
    </div>
  );
};
